// this file is generated by build/compile-schemas.js
import { validateCompiled, } from '../validator.js';
import { appointmentBookRequest, } from './AppointmentApi.generated.mjs';
import { appointmentBookRequestSchema, } from './AppointmentApi.js';
export function appointmentBookRequestValidate(props) {
    return validateCompiled(appointmentBookRequest, props);
}
import { appointmentBookResponse, } from './AppointmentApi.generated.mjs';
import { appointmentBookResponseSchema, } from './AppointmentApi.js';
export function appointmentBookResponseValidate(props) {
    return validateCompiled(appointmentBookResponse, props);
}
import { appointmentSaveRequest, } from './AppointmentApi.generated.mjs';
import { appointmentSaveRequestSchema, } from './AppointmentApi.js';
export function appointmentSaveRequestValidate(props) {
    return validateCompiled(appointmentSaveRequest, props);
}
import { appointmentSaveResponse, } from './AppointmentApi.generated.mjs';
import { appointmentSaveResponseSchema, } from './AppointmentApi.js';
export function appointmentSaveResponseValidate(props) {
    return validateCompiled(appointmentSaveResponse, props);
}
import { searchBookableAppointmentsRequest, } from './AppointmentApi.generated.mjs';
import { searchBookableAppointmentsRequestSchema, } from './AppointmentApi.js';
export function searchBookableAppointmentsRequestValidate(props) {
    return validateCompiled(searchBookableAppointmentsRequest, props);
}
import { searchBookableAppointmentsResponse, } from './AppointmentApi.generated.mjs';
import { searchBookableAppointmentsResponseSchema, } from './AppointmentApi.js';
export function searchBookableAppointmentsResponseValidate(props) {
    return validateCompiled(searchBookableAppointmentsResponse, props);
}
//# sourceMappingURL=AppointmentApi.binding.js.map